/* =============================================================
   VESSEL TYPES
   =============================================================
   Labels for the `vessel_type` enum, on the client for the same
   reason amenity labels are — see the long note in amenities.ts,
   and 20260919085934_drop_amenities_lookup for the argument.

   Short version: nothing can hold a foreign key to this enum,
   so a table beside it would hold only the words, and the words
   are the part that gets translated when the app follows
   `landing/` into en/de/hu.

   THE GUARANTEE is the same one: `Record<VesselType, string>` is
   exhaustive, so a value added to the enum and the union without
   a label here fails the build.
   ============================================================= */

import type { VesselType } from './types'

/** Enum declaration order, which is display order — `order by type` in SQL
 *  sorts the same way, so a report and this dropdown agree. */
export const VESSEL_TYPE_ORDER: VesselType[] = ['passenger', 'cargo', 'hotel_ship', 'event_ship']

const LABELS: Record<VesselType, string> = {
  passenger: 'Passenger ship',
  cargo: 'Cargo vessel',
  hotel_ship: 'Hotel ship',
  event_ship: 'Event ship',
}

/** The four, in display order — what the type dropdown iterates. */
export const VESSEL_TYPES = VESSEL_TYPE_ORDER.map((code) => ({ code, label: LABELS[code] }))

/** Hook-shaped like useAmenities(), so call sites read the same. No fetch:
 *  the labels are compiled in, so this cannot be empty or late. */
export function useVesselTypes() {
  return {
    vesselTypes: VESSEL_TYPES,
    vesselTypeLabel: (code: VesselType): string => LABELS[code] ?? code,
  }
}
